import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { VgnService } from 'src/app/services/vgn/vgn.service';
import { selectContactPersonType } from 'src/app/store/selectors/account-permissions.selector';
import { CONTENT_PLACEHOLDERS } from 'src/common/constants/constants';
import { environment } from 'src/environments/environment';
import {
    AdobeAnalyticsCallToAction,
    AnalyticsCtaType,
} from '../../../services/adobe-launch/adobe-launch.cta';
import { AdobePageName } from '../../../services/adobe-launch/adobe-launch.pages';
import { AdobeLaunchService } from '../../../services/adobe-launch/adobe-launch.service';
import { ContentUtil } from '../../../utils/content/content.util';
import { ClientSegmentContentDTO } from 'src/common/dtos/client-segment.dto';
import { ClientSegmentFacadeService } from 'src/app/services/client-segment-observer/client-segment.service';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'zci-technical-difficulties-page',
    templateUrl: './technical-difficulties-page.component.html',
    styleUrls: ['./technical-difficulties-page.component.scss'],
})
export class TechnicalDifficultiesPageComponent implements OnInit, OnDestroy {
    private store = inject(Store);
    private readonly vgnService = inject(VgnService);
    private adobeLaunchService = inject(AdobeLaunchService);
    private readonly clientSegmentFacadeService = inject(ClientSegmentFacadeService);

    environment = environment;

    readonly content = ContentUtil.grantorFragmentContent;

    contactPersonType$ = this.store.select(selectContactPersonType);

    contactPersonTypePlaceHolder: string = CONTENT_PLACEHOLDERS.CONTACT_PERSON_TYPE;

    popStateHandler = () => {
        window.location.reload();
    };

    errDescription: string;

    private destroy$ = new Subject<void>();

    ngOnInit(): void {
        this.vgnService.setMinimalNav(true);
        this.adobeLaunchService.pageLoad(AdobePageName.TECHNICAL_DIFFICULTIES_PAGE);
        this.refreshOnBackButtonClick();
        this.clientSegmentFacadeService.clientSegmentContent$
            .pipe(takeUntil(this.destroy$))
            .subscribe((content: ClientSegmentContentDTO) => {
                this.errDescription = this.content.add_user.zciTechnicalDifficultiesCallErrorMessage.text1.replace(
                    '${contactYourPoc}',
                    content?.contactYourPoc
                )
            });
    }

    ngOnDestroy(): void {
        this.vgnService.setMinimalNav(false);
        window.removeEventListener('popstate', this.popStateHandler);
        this.destroy$.next();
        this.destroy$.complete();
    }

    refreshOnBackButtonClick(): void {
        window.addEventListener('popstate', this.popStateHandler);
    }

    trackReturnToProfileAndAccountSettingsLink(): void {
        const callToActionData: AdobeAnalyticsCallToAction = {
            ctaName: 'return_to_profile_and_account_settings',
            location: 'give_us_a_call',
            ctaType: AnalyticsCtaType.LINK,
        };
        this.adobeLaunchService.trackAction(callToActionData);
    }
}
